export default {
  namespaced: true,
  state: {
    state: [
      { name: '未選択', value: 0 },
      { name: '指導中', value: 1 },
      { name: '休止', value: 2 },
      { name: 'CXL', value: 3 },
      { name: '終了', value: 4 }
    ],

    gender: [
      { name: '未選択', value: 0 },
      { name: '男', value: 1 },
      { name: '女', value: 2 }
    ],

    school_type: [
      { name: '未選択', valu: 0 },
      { name: '公立', value: 1 },
      { name: '国立', value: 2 },
      { name: '私立', value: 3 },
      { name: 'その他', value: 4 }
    ],

    grade: [
      { name: '', value: '' },
      { name: '幼稚園年少', value: '幼稚園年少' },
      { name: '幼稚園年中', value: '幼稚園年中' },
      { name: '幼稚園年長', value: '幼稚園年長' },
      { name: '小学1年生', value: '小学1年生' },
      { name: '小学2年生', value: '小学2年生' },
      { name: '小学3年生', value: '小学3年生' },
      { name: '小学4年生', value: '小学4年生' },
      { name: '小学5年生', value: '小学5年生' },
      { name: '小学6年生', value: '小学6年生' },
      { name: '中学1年生', value: '中学1年生' },
      { name: '中学2年生', value: '中学2年生' },
      { name: '中学3年生', value: '中学3年生' },
      { name: '高校1年生', value: '高校1年生' },
      { name: '高校2年生', value: '高校2年生' },
      { name: '高校3年生', value: '高校3年生' }
    ],

    priority: [
      { name: '未選択', value: 0 },
      { name: 'メイン', value: 1 },
      { name: 'サブ', value: 2 }
    ],

    inheritance_result: [
      { name: '', value: 0 },
      { name: '成功', value: 1 },
      { name: '失敗', value: 2 },
      { name: '保留', value: 3 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    state (state) { return state.state },
    gender (state) { return state.gender },
    school_type (state) { return state.school_type },
    grade (state) { return state.grade },
    priority (state) { return state.priority },
    inheritance_result (state) { return state.inheritance_result }
  }
}



// WEBPACK FOOTER //
// ./src/store/students.js